import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from '@material-ui/core/TextField';


export default function FormDialog(props) {
  const [vigencia, setVigencia] = useState(0);
  const cambiarVigencia = (event) => {
    setVigencia(event.target.value)
  }
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"¿Está seguro que Aprobar la Solicitud de convenio?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Los registros podrán editarse más adelante.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Vigencia del Convenio en años"
            type="number"
            fullWidth
            variant="standard"
            value={vigencia}
            onChange={(event) => cambiarVigencia(event)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => props.onAccept(vigencia)} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
